import { useState } from 'react';

import { useIsomorphicLayoutEffect } from '@revenuemarket/react';

import useCodef from '~hooks/useCodef';
import { CodefCertificateHardDiskPath } from '~models/certificate';
import { RefinedCodefCert } from '~types/codef';
import getRefinedCertData from '~utils/codef/getRefinedCertData';

const useCertificateSetup = () => {
  const [certificates, setCertificates] = useState<RefinedCodefCert[]>([]);
  const [drivePath, setDrivePath] = useState(CodefCertificateHardDiskPath);
  const [drivePaths, setDrivePaths] = useState<string[]>([]);
  const [selectedCertificate, setSelectedCertificate] = useState<RefinedCodefCert>();
  const [certificateByFind, setCertificateByFind] = useState<{
    encoded: string;
    extracted?: string;
    fileName?: string;
  }>();

  const { requestExternalDrive, requestExportCertificate, requestGetCertification } = useCodef();

  useIsomorphicLayoutEffect(() => {
    (async () => {
      try {
        const drivePaths = await requestExternalDrive();
        setDrivePaths(drivePaths);
      } catch {}
    })();
  }, []);

  useIsomorphicLayoutEffect(() => {
    requestGetCertification(drivePath).then((result) => {
      const availableCertificates = getRefinedCertData(result).filter(
        (cert) => cert?.status === 'NORMAL',
      );

      setCertificates(availableCertificates);
    });

    return () => {
      setCertificates([]);
    };
  }, [requestGetCertification, drivePath]);

  return {
    certificates,
    drivePaths,
    drivePath,
    setDrivePath,
    requestExportCertificate,
    selectedCertificate,
    setSelectedCertificate,
    certificateByFind,
    setCertificateByFind,
  };
};

export default useCertificateSetup;
